/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Product Price related scripts

define('modules/Product/ProductPrice',[
    'jquery',
    'lodash',
    'global/all',
    // BEGIN CUSTOMIZATION : to update price based on quantity discount
    'plugins/accounting.min',
    'modules/Product/ProductService', //CUSTOMIZATION
], function ($, _, Roc, accounting, ProductService) {
    'use strict';
    var _quantityDiscounts;
    var _unitPrice;
    var activeProductId;

    function getProductPricing() {
        if (activeProductId) {
            ProductService.getProductPricing(activeProductId)
                .then(function(productPricing) {
                    Roc.UI.template('productPricingDetailsPDP-Tmp', productPricing).then(function(renderedTemplate) {
                        $('[data-roc-binding="pricing"]').html(renderedTemplate);
                        $('[data-roc-binding="add-to-cart-btn"]').show();
                    });
                });
        }
    }

    function loadProductsPricing(productIds) {
        ProductService.loadProductsPricing(productIds)
            .then(function (productsPricing) {
                _.each(productsPricing, function (response) {
                    Roc.UI.template('productPricingListingPage-Tmp', response.result).then(function (renderedTemplate) {
                        $('[data-product-id="' + response.productId + '"] .currentPrice').html(renderedTemplate);
                    });
                });
            });
    }

    function loadFavoritesProductsPricing(productIds) {
        ProductService.loadProductsPricing(productIds)
            .then(function (productsPricing) {
                _.each(productsPricing, function (response) {
                    Roc.UI.template('productPricing-Tmp', response.result).then(function (renderedTemplate) {
                        $('[data-product-id="' + response.productId + '"] .itemPrice').html(renderedTemplate);
                    });
                });
            });
    }

    function reloadProductPrice(viewModel) {
        $('*[data-element-type="productTitle"]').html(viewModel.name);
        
        // Packard Customization 
        Roc.UI.template('productPrice-Tmp', viewModel).then(function (renderedTemplate) {
            $('[data-roc-binding="pricing"]').html(renderedTemplate);
        });
        if (viewModel.productPricing && viewModel.productPricing.userUnitPrice) {
            $("#totalPrice").html("<span>Total Price: " + accounting.formatMoney(viewModel.productPricing.userUnitPrice) + "</span><br />");
        }

        //TODO: KITS

        if (viewModel.productType === 'Simple') {
            $('.itemSku').html('Item #: <span itemprop="sku">' + viewModel.sku + '</span>');
          
            if (viewModel.productPricing && viewModel.productPricing.customFields && viewModel.productPricing.customFields["quantityDiscounts"]) {
                var qtyBreaks = viewModel.productPricing.customFields["quantityDiscounts"];
                _quantityDiscounts = qtyBreaks;
                Roc.UI.template('quantityDiscounts-Tmp', qtyBreaks).then(function (renderedTemplate) {
                    $('.itemQuantityDiscounts').html(renderedTemplate);
                });
            } else {
                $('.itemQuantityDiscounts').empty();
            }
            // End Packard Customization 
        } else {
            $('.itemSku').empty();
        }

        var $QuoteBtn = $('#QuoteBtn[href*=\'ProductId\']');
        if ($QuoteBtn.length > 0) {
            var href = $QuoteBtn.attr('href');
            $QuoteBtn.attr('href', href.substring(0, href.indexOf('=') + 1) + viewModel.id);
        }
    }
    //BEGIN CUSTOMIZATION : to update price based on quantity discount
    function bindQuantityDiscountsEvents() {
        Roc.UI.siteBody
            .off('change', '#purchaseQuantity')
            .on('change', '#purchaseQuantity', function (e) {
                var currentQty = parseInt($(this).val());
                if (isNaN(currentQty) || currentQty <= 0) {
                    currentQty = 1;
                }
                if (_quantityDiscounts && _quantityDiscounts.length > 0) {
                    var price;
                    for (var i = 0; i < _quantityDiscounts.length; i++) {
                        var matchingBreak = _quantityDiscounts[i];
                        if (currentQty >= matchingBreak.qty) {
                            price = matchingBreak.unitPrice;
                        }
                    }
                    if (!price) {
                        price = _unitPrice.replace("$", "");
                    }
                    if (price && price > 0 && currentQty > 0) {
                        var totalPrice = price * currentQty;
                        $("#totalPrice").html("<span>Total Price: " + accounting.formatMoney(totalPrice) + "</span><br />");
                    }
                    if (price) {
                        $('[data-roc-binding="pricing"] [itemprop="price"]').html(accounting.formatMoney(price));
                    }
                }
            });
    }
    // END CUSTOMIZATION

    function init(quantityDiscounts, productId) {
        bindQuantityDiscountsEvents();
        _unitPrice = $('[data-roc-binding="pricing"] [itemprop="price"]').html();
        if (quantityDiscounts) {
            _quantityDiscounts = quantityDiscounts;
        }
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductPrice);

        if (productId) {
            activeProductId = productId;
            getProductPricing();
        }
    }

    var ProductPrice = {
        init: init,
        loadProductsPricing: loadProductsPricing,
        loadFavoritesProductsPricing: loadFavoritesProductsPricing
    };

    Roc.Logger.debug('ProductPrice.js Loaded:', ProductPrice);

    return ProductPrice;
});
